import { api } from "../services/apiService";

// The QLink drawer may promise "N free ABSITE questions today" only when the
// server says so for THIS account: its selected plan is free ($0) and covers
// ABSITE, and the daily tally (the same one the quiz-create guard enforces:
// plan questionsPerDay minus quiz questions used today) leaves N > 0. A partly
// used allowance is shown as "N left today". Anything else (a paid plan, an
// exhausted allowance, a tutor, a failed or odd response) yields null and the
// plain label.

export const FREE_ALLOWANCE_EXAM = "ABSITE";

const COUNT_QUESTION_OPTIONS = { unused: true, correct: false, incorrect: false, marked: false };

export const resolveFreeExamAllowance = (plans, count, exam = FREE_ALLOWANCE_EXAM) => {
  // The selected-plan endpoint returns a list; the server uses its first entry.
  // More than one selected plan is ambiguous, so no promise.
  const selected = Array.isArray(plans) ? plans : [];
  if (selected.length !== 1) {
    return null;
  }
  const plan = selected[0];
  const coversExam = Array.isArray(plan?.examTypes) && plan.examTypes.includes(exam);
  if (plan?.price !== 0 || !coversExam) {
    return null;
  }
  const limit = count?.questionInDayLimit;
  const left = count?.questionLeftInDay;
  // For a non-student the count endpoint reports the bank size as the limit,
  // so the limit must be this plan's own daily allowance.
  if (!Number.isInteger(limit) || !Number.isInteger(left) || limit !== plan.questionsPerDay || left <= 0 || left > limit) {
    return null;
  }
  return { left, limit };
};

export const fetchFreeExamAllowance = async (userId, exam = FREE_ALLOWANCE_EXAM, client = api) => {
  if (!userId || typeof client?.getUserPackage !== "function" || typeof client?.getQuestionCount !== "function") {
    return null;
  }
  try {
    const [plans, count] = await Promise.all([
      client.getUserPackage(userId),
      client.getQuestionCount({ userId, questionOptions: COUNT_QUESTION_OPTIONS, categoryMap: { examType: [exam] } }),
    ]);
    return resolveFreeExamAllowance(plans, count, exam);
  } catch (_) {
    return null;
  }
};

export const startPracticingLabel = (allowance, exam = FREE_ALLOWANCE_EXAM) => {
  if (!allowance) {
    return "Start practicing";
  }
  const { left, limit } = allowance;
  if (left === limit) {
    return `Start practicing (${limit} free ${exam} questions today)`;
  }
  return `Start practicing (${left} free ${exam} question${left === 1 ? "" : "s"} left today)`;
};
